import AlertsContext from "common/providers/alerts";
import useRouter from "common/hooks/use-router";
import useItem from "common/hooks/useItem";
import { useCallback, useContext, useEffect } from "react";
import { useTranslation } from "react-i18next";
import SuperfamilyForm from "./SuperfamilyForm";

function Superfamily() {
  const { t } = useTranslation();
  const router = useRouter();
  const { setAlert } = useContext(AlertsContext);

  const id = router.query.id as string;

  const { saveItem, updateItem, item, error, isFetching }: any = useItem(
    "superfamilies",
    id,
    {}
  );

  useEffect(() => {
    if (error) {
      setAlert(error, "danger");
    }
  }, [error, setAlert]);

  const back = useCallback(() => {
    if (!error) {
      setAlert(t("common.saved"), "success");
      router.navigate("/superfamilies");
    }
  }, [setAlert, router, error, t]);

  const onSubmit = useCallback(
    async (dataSuperfamily: any) => {
      const newSuperfamily = { ...dataSuperfamily };

      try {
        if (newSuperfamily.id) {
          await updateItem(newSuperfamily.id, newSuperfamily);
        } else {
          await saveItem(newSuperfamily);
        }
      } catch (e: any) {
        return e;
      }
      back();
      return true;
    },
    [updateItem, back, saveItem]
  );

  return isFetching || (id && !item) ? null : (
    <SuperfamilyForm onSubmit={onSubmit} superfamily={item} />
  );
}

export default Superfamily;
